import { elementExists } from '../util/dom';
import Glide, { Breakpoints, Swipe, Controls } from '@glidejs/glide/dist/glide.modular.esm';
import { LazyLoading } from './component/lazyLoading';

const TRIP_OFFER_SELECTOR = '.glide.glide--trip-offer';
const TRIP_COUNTRY_SELECTOR = '.glide.glide--countries';

export const classes = {
    direction: {
        ltr: 'glide--ltr',
        rtl: 'glide--rtl'
    },
    slider: 'glide--slider',
    carousel: 'glide--carousel',
    swipeable: 'glide--swipeable',
    dragging: 'glide--dragging',
    cloneSlide: 'glide__slide--clone',
    activeNav: 'glide-active',
    activeSlide: 'glide__slide--active',
    disabledArrow: 'glide__arrow--disabled'
};

export async function createSliderListeners (): Promise<void> {
    if (elementExists('.glide.glide--background')) {
        const { createBackgroundListeners } = await import('./background'/* webpackChunkName: "slider-background" */);
        createBackgroundListeners();
    }

    if (elementExists('.glide.glide--organizer-logos')) {
        const { createOrganizerListeners } = await import('./organizer'/* webpackChunkName: "slider-organizer" */);
        createOrganizerListeners();
    }

    if (elementExists(TRIP_COUNTRY_SELECTOR)) {
        const dotWidth = 14;
        document.querySelectorAll<HTMLElement>(TRIP_COUNTRY_SELECTOR).forEach(slider => {
            const glide = new Glide(slider, {
                type: 'slider',
                perView: 3,
                classes,
                bound: true,
                rewind: true,
                gap: 30,
                dragThreshold: false,
                breakpoints: {
                    1440: {
                        peek: { before: 0, after: 100 }
                    },
                    900: {
                        perView: 2,
                        gap: 24,
                        peek: { before: 0, after: 80 }
                    },
                    719: {
                        perView: 1,
                        gap: 8,
                        peek: { before: 0, after: 80 }
                    }
                },
            }).mount({ LazyLoading, Swipe, Breakpoints, Controls });

            glide.on('run.after', () => {
                const currentIndex = glide.index;
                const dotArray = slider.querySelectorAll('.js-carousel-dot');
                const dotArrayLength = dotArray.length;
                const carouselDots = slider.querySelector<HTMLElement>('.js-carousel-dot-wrapper');
                const smallDotClass = 'c-carousel__dot-item--small';
                let smallDots;

                if (currentIndex > 2 && currentIndex <= dotArrayLength - 2) {
                    const firstVisibleDot = currentIndex - 2;

                    smallDots = [ firstVisibleDot, currentIndex + 2 ];
                    carouselDots.style.transform = 'translateX(-' + dotWidth * firstVisibleDot + 'px)';
                }
                if (currentIndex === 2) {
                    smallDots = [ 0, 4 ];
                }
                if (currentIndex < 2) {
                    smallDots = [ -1, 4 ];
                    carouselDots.style.transform = 'translateX(0)'

                }
                if (currentIndex >= dotArrayLength - 2) {
                    const firstVisibleDot = dotArrayLength - 5;

                    smallDots = [ firstVisibleDot, -1 ];
                    carouselDots.style.transform = 'translateX(-' + (dotWidth * firstVisibleDot) + 'px)';
                }

                dotArray.forEach(dot => {
                    dot.classList.remove(smallDotClass)
                })

                smallDots.forEach(dot => {
                    if (dotArray[dot]){
                        dotArray[dot].classList.add(smallDotClass)
                    }
                })
            });
        });
    }

    if (elementExists(TRIP_OFFER_SELECTOR)) {
        document.querySelectorAll<HTMLElement>(TRIP_OFFER_SELECTOR).forEach(slider => {
            new Glide(slider, {
                type: 'carousel',
                perView: 3,
                gap: 0,
                focusAt: 1,
                bound: true,
                classes,
                swipeThreshold: 24,
                breakpoints: {
                    600: {
                        perView: 1,
                        peek: 25
                    },
                    940: {
                        perView: 2
                    }
                },
                peek: 50
            }).mount({ LazyLoading, Swipe, Breakpoints });
        });
    }
}
